// TODO: refactor this
export const getPadding = (style: any) => {
  const { padding, paddingTop, paddingRight, paddingBottom, paddingLeft } = style

  let styles = {
    padding: ``,
    paddingTop: ``,
    paddingBottom: ``,
    paddingLeft: ``,
    paddingRight: ``,
  }
  if(padding) {
    styles = {
      padding: `${padding}px`,
      paddingTop: `${padding}px`,
      paddingBottom: `${padding}px`,
      paddingLeft: `${padding}px`,
      paddingRight: `${padding}px`,
    }
  }

  if(paddingTop) {
    styles.paddingTop = `${paddingTop}px`
  }

  if(paddingLeft) {
    styles.paddingLeft = `${paddingLeft}px`
  }

  if(paddingRight) {
    styles.paddingRight = `${paddingRight}px`
  }

  if(paddingBottom) {
    styles.paddingBottom = `${paddingBottom}px`
  }

  return styles
}

type MarginStyles = {
  margin?: string;
  marginTop?: string;
  marginRight?: string;
  marginBottom?: string;
  marginLeft?: string;
  alignX?: string;
}
export const getMargin = (style: MarginStyles) => {
  const { margin, marginTop, marginRight, marginBottom, marginLeft, alignX } = style

  let styles = {
    margin: ``,
    marginTop: ``,
    marginBottom: ``,
    marginLeft: ``,
    marginRight: ``,
  }
  if(margin) {
    styles = {
      margin: `${margin}px`,
      marginTop: `${margin}px`,
      marginBottom: `${margin}px`,
      marginLeft: `${margin}px`,
      marginRight: `${margin}px`,
    }
  }

  if(marginTop) {
    styles.marginTop = `${marginTop}px`
  }

  if(marginLeft) {
    styles.marginLeft = `${marginLeft}px`
  }

  if(marginRight) {
    styles.marginRight = `${marginRight}px`
  }

  if(marginBottom) {
    styles.marginBottom = `${marginBottom}px`
  }

  return styles
}

export const getGridStyles = (style: any) => {
  let styles = ''

  if(style.gridCols) {
    styles += `grid-cols-${style.gridCols}`
  }
  if(style.gridRows) {
    styles += ` grid-rows-${style.gridRows}`
  }


  return styles
}